import { useUserAccount } from '@/api/user';
import { UserRankCard } from '@/components/UserRankCard';
import { useComponentVariant } from '@/hooks/theme/useComponentVariant';
import useLayoutSettings from '@/hooks/theme/useLayoutSettings';
import { SettingLayoutComponentId } from '@starsoft/common/models';
import { ComponentTypeId } from '@starsoft/common/models/setting/layout/component/type/types.enum';
import NavbarLink from '../Item/Link';
import MenuButton from '../Menu/Button';
import GameSearchLink from '../Search';
import styles from '../styles.module.scss';
import { NavbarContentProps } from './props';

export default function NavbarContent({ isVariant }: NavbarContentProps) {
  const { isV4LayoutVariant } = useLayoutSettings();
  const { isAuthorized } = useUserAccount();
  const userPlayerId =
    useComponentVariant(ComponentTypeId.UserProfileChip)?.toString() ??
    SettingLayoutComponentId.UserProfileChipV1?.toString();

  return (
    <div
      className={`${styles.container} ${isVariant ? styles['container--v2'] : ''}`}
    >
      <MenuButton />
      <GameSearchLink />
      <NavbarLink
        label="tournament_tabs"
        href="/tournaments"
        icon="fa-solid fa-trophy"
      />

      <NavbarLink
        label="tab_casino"
        icon="fa-solid fa-spade fa-swap-opacity"
        href="/casino"
      />
      {(isV4LayoutVariant && isAuthorized && (
        <>
          <UserRankCard id={userPlayerId} navigation />
        </>
      )) || (
        <NavbarLink
          label="tab_sportsbook"
          icon="fa-solid fa-basketball"
          href="/sports"
        />
      )}
    </div>
  );
}
